import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardNoNameComponent } from './card-no-name.component';
import { VincularCardComponent } from './vincular-card/vincular-card.component';
import { CardNoNameRoutingModule } from './card-no-name-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NbTabsetModule, NbRouteTabsetModule, NbStepperModule, NbButtonModule, NbListModule, NbAccordionModule, NbUserModule, NbCardModule, NbIconModule, NbInputModule, NbTreeGridModule, NbSpinnerModule } from '@nebular/theme';
import { Ng2SmartTableModule } from 'ng2-smart-table';
import { ThemeModule } from '../../@theme/theme.module';
import { NgxMaskModule } from 'ngx-mask';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { ComponentstModule } from '../../shared/components/components.module';
import { ModalAssociarCardComponent } from './vincular-card/modal-associar-card/modal-associar-card.component';

@NgModule({   
  imports: [
    CommonModule,
    CardNoNameRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NbTabsetModule,
    NbRouteTabsetModule,
    NbStepperModule,
    NbButtonModule,
    NbListModule,
    NbAccordionModule,
    NbUserModule,
    NbCardModule,
    NbIconModule,
    NbInputModule,
    NbTreeGridModule,
    Ng2SmartTableModule,
    ThemeModule,
    NgxMaskModule.forRoot(),
    NgxDatatableModule,
    ComponentstModule,
    NbSpinnerModule,
  ],
  declarations: [
    CardNoNameComponent, 
    VincularCardComponent, 
    ModalAssociarCardComponent,

  ], 
  entryComponents:[
    ModalAssociarCardComponent
  ]
})
export class CardNoNameModule { }
